export default "__VITE_ASSET__e0715b27__"